import React from "react";
import BlogTwentyFour from "../component/BlogTwentyFour";

function BlogTwentyFourContainer() {
  return <BlogTwentyFour />;
}
export default BlogTwentyFourContainer;
